<template>
    <div v-if="eventData && eventData.organizerLogo && !eventData.alternativeOrganizer" class="img-container">
        <img class="img" :src="eventData.organizerLogo" :alt="eventData.organizerName"/>
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "AnbieterLogo",
    mixins: [mainRegistrationMixin]
}
</script>

<style scoped>
.img-container {
    overflow: hidden;
}

.img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>